document.addEventListener('DOMContentLoaded', function(evt) {
  const body = document.querySelector('body');

  // Trigger variant selection on product pages (only if swatch exists)
  // Wait for jQuery and product JS to be ready before triggering click
  if (window.location.href.includes("/products")) {
    var waitForJQuery = setInterval(function() {
      if (typeof $ !== 'undefined' && $.fn && $.fn.jquery) {
        clearInterval(waitForJQuery);
        $(document).ready(function() {
          setTimeout(function() {
            var widthButton = document.querySelector('.size-swatch');
            if (widthButton) {
              widthButton.click();
            }
          }, 100);

          // Hide out-of-stock variants after each attribute selection update
          $('body').on('product:afterAttributeSelect', function(e, response) {
            if (response.data && response.data.product && response.data.product.variationAttributes) {
              response.data.product.variationAttributes.forEach(function(attr) {
                attr.values.forEach(function(val) {
                  var swatch = response.container.find('[data-attr="' + attr.id + '"] [data-attr-value="' + val.value + '"]');
                  if (!val.selectable) {
                    swatch.hide();
                  } else {
                    swatch.show();
                  }
                });
              });
            }
          });
        });
      }
    }, 50);
  }

  // Activate Slick slideshow
  if (body.classList.contains('template-index')) {
    var waitForSlick = setInterval(function() {
      if (typeof $ !== 'undefined' && $.fn && $.fn.slick) {
        clearInterval(waitForSlick);
        var $slideshow = $('.slideshow__list');
        var slideCount = $slideshow.children().length;

        if (slideCount > 0) {
          $slideshow.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: slideCount > 1,
            dots: slideCount > 1,
            autoplay: slideCount > 1,
            autoplaySpeed: 5000
          });
        }
      }
    }, 50);
  }
});